import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "show",
  "use": "show-usage",
  "viewBox": "0 0 26 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 16\" id=\"show\"><defs><style>#show .cls-1{fill-rule:evenodd}</style></defs><path class=\"cls-1\" d=\"M13 0c6.76 0 13 4.385 13 8s-6.24 8-13 8S0 11.615 0 8s6.24-8 13-8zm0 1.454c5.91 0 11.47 3.734 11.47 6.545S18.91 14.545 13 14.545 1.53 10.811 1.53 7.999 7.09 1.455 13 1.455zm0 2.9A3.648 3.648 0 1 1 9.16 8 3.746 3.746 0 0 1 13 4.357zm0 1.107A2.539 2.539 0 1 1 10.34 8 2.6 2.6 0 0 1 13 5.464z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/show.svg
// module id = vsUp
// module chunks = 6